/** Salon pay model — shared labels & helpers. */

export const DEFAULT_PAYROLL = {
    salon_pay_model: "mixed",
    pay_period: "monthly",
    commission_basis: "pre_discount",
    commission_on_products: false,
    default_commission_pct: 40,
    default_base_salary: 15000,
};

export const STAFF_ROSTER_ROLES = {
    stylist: "Stylist — hair, colour, cuts",
    therapist: "Therapist — spa, massage, skin",
    manager: "Manager — on roster only",
    receptionist: "Receptionist — front desk",
};

export const SALON_PAY_MODELS = {
    commission: {
        label: "Commission based",
        short: "Commission",
        description: "Stylists earn a percentage of the service revenue they perform.",
    },
    fixed: {
        label: "Fixed salary",
        short: "Fixed pay",
        description: "Everyone is on a monthly or weekly salary. No commission tracking.",
    },
    mixed: {
        label: "Mixed team",
        short: "Mixed",
        description: "Some staff on salary, some on commission, or hybrid (salary + commission).",
    },
};

export const PAY_TYPE_LABELS = {
    commission: "Commission",
    fixed: "Fixed salary",
    hybrid: "Base + commission",
};

export function allowedPayTypes(salonPayModel = "mixed") {
    if (salonPayModel === "fixed") return ["fixed"];
    if (salonPayModel === "commission") return ["commission"];
    return ["commission", "fixed", "hybrid"];
}

export function defaultPayType(salonPayModel = "mixed") {
    if (salonPayModel === "fixed") return "fixed";
    return "commission";
}

export function defaultStaffForm(salonPayModel = "mixed") {
    const pay_type = defaultPayType(salonPayModel);
    return {
        full_name: "",
        role: "stylist",
        mobile: "",
        email: "",
        color: "#C84B31",
        pay_type,
        commission_pct: salonPayModel === "fixed" ? 0 : 40,
        base_salary: salonPayModel === "fixed" ? 15000 : 0,
        salary_period: "monthly",
        commission_threshold: 0,
    };
}
